import { Breakpoints, styled } from "@vw-marketing/us-components";

import { VWTheme } from "../../../../shared/typings/vw-theme";

export const StyledDeactivateErrorContainer: any = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 72svh;
  justify-content: space-between;
`;

export const StyledErrorHeaderContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static300};
      justify-content: center;

      svg {
        color: ${theme.colors.signal.error};
      }
    `;
  }}
`;

export const StyledNameErrorDescriptionContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      align-items: center;
      display: flex;
      justify-content: center;
      padding-top: ${theme.size.static150};
    `;
  }}
`;

export const StyledButtonsContainer: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      gap: ${theme.size.static350};
      justify-content: space-between;
      width: 100%;

      @media (min-width: ${Breakpoints.b1920}px) {
        justify-content: flex-end;
      }
    `;
  }}
`;
